import { Button } from 'components/Button'
import { useModals } from 'almanac-ui/Modal'

export const BackButton = () => {
  const { closeModal } = useModals()

  return (
    <Button size="lg" variant="tertiary" onPress={closeModal}>
      Back
    </Button>
  )
}
